import React from 'react'

const Tag = ({text}) => {
  return (
    <div className='wraper w-max py-1 px-2 mt-4 rounded-md font-bold text-sm mr-2' >{text}</div>
  )
}

export default Tag